import { NewDynamicTab } from "../../../components/Page";
import { GridcoPowerGenrationDefaultDates } from "../../../config/DefaultDates";
import { GridcoTitle } from "../components";
import { TabSwitcher } from "../Gridco_Das";
import { BySource } from "./BySource";
import { GridcoTrend } from "./Gridco_trend";
import { GridcoGenrationIntrastate } from "./Intrastate";
import { GridcoGenrationIsgs } from "./ISGS";
import { GridcoGenrationOverview } from "./Overview";
import { ByPowerStation } from "./PowerStation";

export function GridcoGenration() {
  return (
    <>
      <NewDynamicTab
        defaultDates={GridcoPowerGenrationDefaultDates}
        header="Generation"
        trendTabs={["Trend Analysis"]}
        middleComponent={<GridcoTitle />}
        headerPrefixComponent={<TabSwitcher />}
        tabs={{
          Overview: <GridcoGenrationOverview />,
          "Trend Analysis": <GridcoTrend />,
          // "By Source": <BySource />,
          // "By Power Station": <ByPowerStation />,
          ISGS: <GridcoGenrationIsgs />,
          Intrastate: <GridcoGenrationIntrastate />,
        }}
      />
    </>
  );
}
